import React, { useCallback } from 'react';
import { Box, Tooltip } from '@mui/material';
import NavigationMenu from '../NavigationMenu/NavigationMenu';
import { ArrowLeftSLineIcon, ArrowRightSLineIcon, HomeIcon } from '../RemixIcons/generated/remixIcons';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getSidebarExpanded } from 'src/shared/store/embedSelectors';
import { setSidebarExpanded } from 'src/shared/store/embedSlice';
import styles from './PlatformSidebar.module.scss';
import classNames from 'classnames';

export const CLOSED_WIDTH = '60px';
export const EXPANDED_WIDTH = '260px';

export const ExpandButton = ({ expanded, onClick, className }) => {
  return (
    <button
      type="button"
      aria-label={expanded ? 'Collapse sidebar' : 'Expand sidebar'}
      className={classNames(className, styles.customExpandButton, { [styles.collapsed]: !expanded })}
      onClick={onClick}
    >
      {expanded ? <ArrowLeftSLineIcon /> : <ArrowRightSLineIcon />}
    </button>
  );
};

export const PlatformSidebar = ({ sx }) => {
  const expanded = useSelector(getSidebarExpanded);
  const dispatch = useDispatch();
  const history = useHistory();

  const requestSidebarExpand = useCallback(() => {
    dispatch(setSidebarExpanded(true));
  }, [dispatch]);

  return (
    <Box
      component="nav"
      className={styles.sidebar}
      sx={[
        {
          width: expanded ? EXPANDED_WIDTH : CLOSED_WIDTH,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <div className={styles.header}>
        <Tooltip
          title="Home"
          placement="right"
          arrow
          disableHoverListener={expanded}
          disableFocusListener={expanded}
          disableTouchListener={expanded}
        >
          <button
            type="button"
            aria-label="Home"
            className={classNames(styles.homeButton, {
              [styles.collapsed]: !expanded,
            })}
            onClick={() => {
              if (history.location.pathname !== '/') {
                history.push('/');
              }
            }}
          >
            <span className={styles.homeIconSlot} aria-hidden="true">
              <HomeIcon />
            </span>
            {expanded && <span className={styles.homeText}>HOME</span>}
          </button>
        </Tooltip>
        <ExpandButton
          expanded={expanded}
          onClick={() => dispatch(setSidebarExpanded(!expanded))}
          className={styles.expandButton}
        />
      </div>
      <div className={styles.menuScrollArea}>
        <NavigationMenu expanded={expanded} onRequestExpand={requestSidebarExpand} />
      </div>
    </Box>
  );
};
